import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";

import Logo from "~/assets/images/logo.svg";

import * as styles from "./styles";

export const Attribution = ({
  sdkName,
  locale,
  onClick,
}: {
  sdkName?: string;
  locale?: string;
  onClick?: () => void;
}) => {
  const { t } = useTranslation(["common"]);

  const href = useMemo(() => {
    const baseUrl = `https://locallogic.co/${typeof locale !== "undefined" && locale !== "en" ? `${locale}/` : ""}`;

    let baseParams: Record<string, string> = {};

    try {
      baseParams = {
        utm_source: document?.referrer || "unknown",
        utm_medium: "referral",
        utm_campaign: sdkName || "unknown-sdk",
      };
    } catch (error) {
      return baseUrl; // Fallback to base URL if there's an error
    }

    const params = new URLSearchParams(baseParams).toString();

    return params ? `${baseUrl}?${params}` : baseUrl;
  }, [sdkName, locale]);

  return (
    <a
      onClick={onClick}
      className={styles.container}
      href={href}
      target="_blank"
      rel="noreferrer"
    >
      {t("common:attribution")}
      <Logo />
    </a>
  );
};

/**
 * @deprecated Use Attribution instead unless you're on the old design system
 *
 * @param param0
 * @returns
 */
export const AttributionDeprecated = ({
  onClick,
}: {
  onClick?: () => void;
}) => {
  const { t } = useTranslation(["common"]);

  return (
    <a
      onClick={onClick}
      className={styles.containerDeprecated}
      href="https://locallogic.co/"
      target="_blank"
      rel="noreferrer"
    >
      {t("common:attribution")}
      <Logo />
    </a>
  );
};
